module.exports = __webpack_public_path__ + "img/qbc-about.b9e9458d.png";